import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import {
  Carousel,
  carouselItem,
  Pagination,
  Button,
  InputNumber,
  Message,
  Input,
  Checkbox,
  Select,
  Option,
  Cascader,
  Dialog, Image,
  MessageBox
} from "element-ui";

Vue.use(Carousel);
Vue.use(carouselItem);
Vue.use(Pagination);
Vue.use(Button);
Vue.use(InputNumber);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(Dialog);
Vue.use(Image);

Vue.prototype.$message = Message; //  这个是注册全局的message 的方法
Vue.prototype.$confirm = MessageBox.confirm

Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
